import React from 'react';

const NotFound = () => (
  <div className="centered">
    <p>Page not found!</p>
  </div>
);

export default NotFound;
